import { color } from "@styles";
import { BetterButton } from "components/atoms/BetterButton";
import { H2 } from "components/atoms/Heading";
import { P1 } from "components/atoms/Paragraph";
import { Spacer } from "components/templates/Spacer";
import Link from "next/link";
import styled from "styled-components";
import { tablet } from "components/templates/Breakpoints";
import { types } from "react-bricks/frontend";

// Styled components for TeamCallout
const SectionWrapper = styled.div<{ backgroundImage: string }>`
  padding: 6.875rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url("${(props) => props.backgroundImage}");
    background-size: cover;
    background-position: center;
    filter: brightness(50%);
    z-index: -1;
  }

  ${tablet} {
    padding: 4rem;
  }
`;

const TextWrap = styled.div`
  max-width: 80%;
`;

const Centered = styled.div`
  text-align: center;
`;

interface TeamCalloutProps {
  teamText: string;
  teamTitle: string;
  buttonText: string;
  buttonLink: string;
  backgroundImage: types.IImageSource;
}

const TeamCallout: types.Brick<TeamCalloutProps> = ({
  teamText,
  teamTitle,
  buttonText,
  buttonLink,
  backgroundImage,
}) => {
  return (
    <SectionWrapper backgroundImage={backgroundImage.src}>
      <TextWrap>
        <Centered>
          <P1 align="center" bold pb="1rem" color={color.white}>
            {teamText}
          </P1>
          <H2 align="center" color={color.white}>
            {teamTitle}
          </H2>
        </Centered>
      </TextWrap>
      <Spacer height="3rem" />
      <Link href={buttonLink}>
        <BetterButton text={buttonText} />
      </Link>
    </SectionWrapper>
  );
};

TeamCallout.schema = {
  name: "image-callout",
  label: "Image Callout",
  category: "content sections",
  previewImageUrl: "/static/bricks/image-callout.png",
  getDefaultProps: () => ({
    teamText: "Our team",
    teamTitle: "We work with a team from all around the world that lives and breathes our mission",
    buttonText: "Join us",
    buttonLink: "/careers",
    backgroundImage: {
      src: "/static/pages/about-us/YuCrew.jpg",
      fallbackSrc: "/static/pages/about-us/YuCrew.jpg",
    },
  }),
  sideEditProps: [
    {
      name: "teamText",
      label: "Heading Text",
      type: types.SideEditPropType.Text,
    },
    {
      name: "teamTitle",
      label: "Main Title",
      type: types.SideEditPropType.Text,
    },
    {
      name: "buttonText",
      label: "Button Text",
      type: types.SideEditPropType.Text,
    },
    {
      name: "buttonLink",
      label: "Button Link",
      type: types.SideEditPropType.Text,
    },
    {
      name: "backgroundImage",
      label: "Background Image",
      type: types.SideEditPropType.Image,
    },
  ],
};

export default TeamCallout;
